import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { JsonResponse } from '../../../../../shared/api/backend-config';
import { environment } from '../../../../../../environments/environment';

export interface FeedbackBody {
  message: string;
  fullName?: string;
  email?: string;
}

@Injectable({
  providedIn: 'root',
})
export class OnboardingGuideService {
  private http = inject(HttpClient);

  private readonly _start$ = new Subject<void>();
  readonly start$ = this._start$.asObservable();

  public start(): void {
    this._start$.next();
  }

  public submitFeedback(body: FeedbackBody): Observable<JsonResponse<any>> {
    return this.http.post<JsonResponse<any>>(
      `${environment.apiUrl}user/metrics/feedback-form `,
      body
    );
  }
}
